module.exports = __webpack_public_path__ + "media/brands/chrysler-b3a5705b.png";